import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './ViewShipment.css';

const ViewReciebleManifest = () => {
  const [manifests, setManifests] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("auth_token="));
    const parsedToken = token
      ? JSON.parse(atob(token.split("=")[1].split(".")[1]))
      : null;

    const branchId = parsedToken?.branchId;
    
    const fetchManifests = async () => {
      try {
        const response = await axios.get(
          `https://kartikenterprisesindia.co.in/api/manifests/receible/?branchId=${branchId}`
        );
        setManifests(response.data);
      } catch (error) {
        console.error("Failed to fetch manifests:", error);
        alert("Failed to fetch manifests.");
      }
    };
    if (branchId) {
      fetchManifests();
    } else {
      console.error("Branch ID is missing or invalid.");
    }
  }, []);

  const handleReceive = async (manifestId) => {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("auth_token="));
    
    const userId = token ? JSON.parse(atob(token.split("=")[1].split(".")[1])).userId : null;
  
    if (!userId) {
      alert("User ID is missing or invalid.");
      return;
    }
  
    try {
      const response = await axios.put(
        "https://kartikenterprisesindia.co.in/api/manifests/receive",
        { manifestId, userId }, // Send both manifestId and userId in the request body
        {
          headers: {
            Authorization: `Bearer ${token.split("=")[1]}`, // Send token for authorization
          },
        }
      );
  
      alert("Manifest received successfully.");
      // Update manifest status in the UI
      setManifests((prevManifests) =>
        prevManifests.map((manifest) =>
          manifest._id === manifestId ? { ...manifest, status: "Received" } : manifest
        )
      );
    } catch (error) {
      console.error("Failed to receive manifest:", error);
      alert("Failed to receive manifest.");
    }
  };
  
  
  const handleDelete = async (manifestId) => {
    if (window.confirm("Are you sure you want to delete this manifest?")) {
      try {
        await axios.delete(`https://kartikenterprisesindia.co.in/api/manifests/${manifestId}`);
        setManifests(manifests.filter((c) => c._id !== manifestId));
        alert("Manifest deleted successfully.");
      } catch (error) {
        alert("Failed to delete manifest.");
      }
    }
  };

  return (
    <div className="view-manifests">
      <h2>manifests</h2>
      <button
        className="create-button"
        onClick={() => navigate("/createmanifest")}
      >
        + Create manifest
      </button>
      <table>
        <thead>
          <tr>
            <th>manifest Number</th>
            <th>Date of manifest</th>
            <th>From (Sender City)</th>
            <th>To (Receiver City)</th>
            <th>Status</th>
            <th>Recieve</th>
            <th>del</th>
          </tr>
        </thead>
        <tbody>
          {manifests.map((manifest) => (
            <tr key={manifest._id}>
              <td>{manifest.manifestId}</td>
              <td>{new Date(manifest.createdAt).toLocaleDateString()}</td>
              <td>{manifest.createdBy.branch.code} </td>
              <td>{manifest.destinationBranch.code}</td> {/* Receiver City */}
              <td>{manifest.status}</td>
              <td>
              <button
                  className="action-button edit-button"
                  style={{ backgroundColor: "green", color: "white" }}
                  onClick={() => handleReceive(manifest._id)} // Call handleReceive with manifestId
                >
                  Recieve
                </button>
              </td>
              
              <td>
                <button
                  className="action-button delete-button"
                  onClick={() => handleDelete(manifest._id)}
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewReciebleManifest;
